import { createReducer } from 'redux-act';
import actions from '../actions/ShiftManagementAction';
import { PAUSE } from 'redux-persist';

const initialState = {
  addShiftPending: false,
  addShiftRes: null,
  addShiftError: null,

  getAllShiftPending: false,
  getAllShiftRes: null,
  getAllShiftError: null,

  getShiftByIdPending: false,
  getShiftByIdRes: null,
  getShiftByIdError: null,

  updateShiftPending: false,
  updateShiftRes: null,
  updateShiftError: null,

  deleteShiftPending: false,
  deleteShiftRes: null,
  deleteShiftError: null,

  addShiftConfigurationPending: false,
  addShiftConfigurationRes: null,
  addShiftConfigurationError: null,

  // getShiftConfigurationPending: false,
  // getShiftConfigurationRes: null,
  // getShiftConfigurationError: null,

  addShiftCalendarPending: false,
  addShiftCalendarRes: null,
  addShiftCalendarError: null,

  getAllShiftCalendarPending: false,
  getAllShiftCalendarRes: null,
  getAllShiftCalendarError: null,

  updateShiftCalendarPending: false,
  updateShiftCalendarRes: null,
  updateShiftCalendarError: null,

  deleteShiftCalendarPending: false,
  deleteShiftCalendarRes: null,
  deleteShiftCalendarError: null,

  assignShiftPending: false,
  assignShiftRes: null,
  assignShiftError: null,

  addWeekOffPending: false,
  addWeekOffRes: null,
  addWeekOffError: null,

  getEmployeebyShiftidPending: false,
  getEmployeebyShiftidRes: null,
  getEmployeebyShiftidError: null,

  getAllShiftDetailsPending: false,
  getAllShiftDetailsRes: null,
  getAllShiftDetailsError: null,

  deleteEmployeeShiftPending: false,
  deleteEmployeeShiftRes: null,
  deleteEmployeeShiftError: null,

  activeOrInactivePending: false,
  activeOrInactiveRes: null,
  activeOrInactiveError: null,

  getEmployeeShiftDetailsByIdPending:false,
  getEmployeeShiftDetailsByIdRes:null,
  getEmployeeShiftDetailsByIdError:null,

};
/* Add Shift  Reducers */
const handleAddShiftRequest = state => {
  return {
    ...state,
    ...{
      addShiftPending: true,
      addShiftRes: null,
      addShiftError: null,
    },
  };
};
const handleAddShiftSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addShiftPending: false,
      addShiftRes: payload,
      addShiftError: null,
    },
  };
};
const handleAddShiftError = (state, payload) => ({
  ...state,
  ...{
    addShiftPending: false,
    addShiftRes: null,
    addShiftError: payload,
  },
});


/* Get All Shift Reducers */
const handleGetAllShiftRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllShiftPending: true,
      getAllShiftRes: null,
      getAllShiftError: null,
    },
  };
};
const handleGetAllShiftSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllShiftPending: false,
      getAllShiftRes: payload,
      getAllShiftError: null,
    },
  };
};
const handleGetAllShiftError = (state1, payload) => ({
  ...state1,
  ...{
    getAllShiftPending: false,
    getAllShiftRes: null,
    getAllShiftError: payload,
  },
});

// get Shift by Id
const handleGetShiftByIdRequest = state1 => {
  return {
    ...state1,
    ...{
      getShiftByIdPending: true,
      getShiftByIdRes: null,
      getShiftByIdError: null,
    },
  };
};
const handleGetShiftByIdSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getShiftByIdPending: false,
      getShiftByIdRes: payload,
      getShiftByIdError: null,
    },
  };
};
const handleGetShiftByIdError = (state1, payload) => ({
  ...state1,
  ...{
    getShiftByIdPending: false,
    getShiftByIdRes: null,
    getShiftByIdError: payload,
  },
});

// Update Shift 
/* Update Shift Reducers */
const handleUpdateShiftRequest = state1 => {
  return {
    ...state1,
    ...{
      updateShiftPending: true,
      updateShiftRes: null,
      updateShiftError: null,
    },
  };
};
const handleUpdateShiftSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateShiftPending: false,
      updateShiftRes: payload,
      updateShiftError: null,
    },
  };
};
const handleUpdateShiftError = (state1, payload) => ({
  ...state1,
  ...{
    updateShiftPending: false,
    updateShiftRes: null,
    updateShiftError: payload,
  },
});

/* Delete Shift Reducers */
const handleDeleteShiftRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteShiftPending: true,
      deleteShiftRes: null,
      deleteShiftError: null,
    },
  };
};
const handleDeleteShiftSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteShiftPending: false,
      deleteShiftRes: payload,
      deleteShiftError: null,
    },
  };
};
const handleDeleteShiftError = (state1, payload) => ({
  ...state1,
  ...{
    deleteShiftPending: false,
    deleteShiftRes: null,
    deleteShiftError: payload,
  },
});

/* Add Shift Configuration  Reducers */
const handleAddShiftConfigurationRequest = state => {
  return {
    ...state,
    ...{
      addShiftConfigurationPending: true,
      addShiftConfigurationRes: null,
      addShiftConfigurationError: null,
    },
  };
};
const handleAddShiftConfigurationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addShiftConfigurationPending: false,
      addShiftConfigurationRes: payload,
      addShiftConfigurationError: null,
    },
  };
};
const handleAddShiftConfigurationError = (state, payload) => ({
  ...state,
  ...{
    addShiftConfigurationPending: false,
    addShiftConfigurationRes: null,
    addShiftConfigurationError: payload,
  },
});

//get Shift Configuration
// const handleGetShiftConfigurationRequest = state1 => {
//   return {
//     ...state1,
//     ...{
//       getShiftConfigurationPending: true,
//       getShiftConfigurationRes: null,
//       getShiftConfigurationError: null,
//     },
//   };
// };
// const handleGetShiftConfigurationSuccess = (state1, payload) => {
//   return {
//     ...state1,
//     ...{
//       getShiftConfigurationPending: false,
//   getShiftConfigurationRes: payload,
//   getShiftConfigurationError: null,
//     },
//   };
// };
// const handleGetShiftConfigurationError = (state1, payload) => ({
//   ...state1,
//   ...{
//     getShiftConfigurationPending: false,
//   getShiftConfigurationRes: null,
//   getShiftConfigurationError: payload,
//   },
// });
/* Get Shift Configuration Reducers */
const handleGetShiftConfigurationRequest = state1 => {
  return {
    ...state1,
    ...{
      getShiftConfigurationPending: true,
      getShiftConfigurationRes: null,
      getShiftConfigurationError: null,
    },
  };
};
const handleGetShiftConfigurationSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getShiftConfigurationPending: false,
  getShiftConfigurationRes: payload,
  getShiftConfigurationError: null,
    },
  };
};
const handleGetShiftConfigurationError = (state1, payload) => ({
  ...state1,
  ...{
    getShiftConfigurationPending: false,
  getShiftConfigurationRes: null,
  getShiftConfigurationError: payload,
  },
});


/* Add Shift Calendar */
const handleAddShiftCalendarRequest = state => {
  return {
    ...state,
    ...{
      addShiftCalendarPending: true,
      addShiftCalendarRes: null,
      addShiftCalendarError: null,
    },
  };
};
const handleAddShiftCalendarSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addShiftCalendarPending: false,
      addShiftCalendarRes: payload,
      addShiftCalendarError: null,
    },
  };
};
const handleAddShiftCalendarError = (state, payload) => ({
  ...state,
  ...{
    addShiftCalendarPending: false,
    addShiftCalendarRes: null,
    addShiftCalendarError: payload,
  },
});


/* Get Shift Calendar */
const handleGetAllShiftCalendarRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllShiftCalendarPending: true,
      getAllShiftCalendarRes: null,
      getAllShiftCalendarError: null,
    },
  };
};
const handleGetAllShiftCalendarSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllShiftCalendarPending: false,
      getAllShiftCalendarRes: payload,
      getAllShiftCalendarError: null,
    },
  };
};
const handleGetAllShiftCalendarError = (state1, payload) => ({
  ...state1,
  ...{
    getAllShiftCalendarPending: false,
    getAllShiftCalendarRes: null,
    getAllShiftCalendarError: payload,
  },
});

/* Update Shift Calendar */
const handleUpdateShiftCalendarRequest = state1 => {
  return {
    ...state1,
    ...{
      updateShiftCalendarPending: true,
      updateShiftCalendarRes: null,
      updateShiftCalendarError: null,
    },
  };
};
const handleUpdateShiftCalendarSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateShiftCalendarPending: false,
      updateShiftCalendarRes: payload,
      updateShiftCalendarError: null,
    },
  };
};
const handleUpdateShiftCalendarError = (state1, payload) => ({
  ...state1,
  ...{
    updateShiftCalendarPending: false,
    updateShiftCalendarRes: null,
    updateShiftCalendarError: payload,
  },
});

/* Delete Shift Calendar */
const handleDeleteShiftCalendarRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteShiftCalendarPending: true,
      deleteShiftCalendarRes: null,
      deleteShiftCalendarError: null,
    },
  };
};
const handleDeleteShiftCalendarSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteShiftCalendarPending: false,
      deleteShiftCalendarRes: payload,
      deleteShiftCalendarError: null,
    },
  };
};
const handleDeleteShiftCalendarError = (state1, payload) => ({
  ...state1,
  ...{
    deleteShiftCalendarPending: false,
    deleteShiftCalendarRes: null,
    deleteShiftCalendarError: payload,
  },
});


// Assign Shift
const handleAssignShiftRequest = state1 => {
  return {
    ...state1,
    ...{
      assignShiftPending: true,
      assignShiftRes: null,
      assignShiftError: null,
    },
  };
};
const handleAssignShiftSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      assignShiftPending: false,
      assignShiftRes: payload,
      assignShiftError: null,
    },
  };
};
const handleAssignShiftError = (state1, payload) => ({
  ...state1,
  ...{
    assignShiftPending: false,
    assignShiftRes: null,
    assignShiftError: payload,
  },
});

// Add Week off
const handleAddWeekOffRequest = state1 => {
  return {
    ...state1,
    ...{
      addWeekOffPending: true,
      addWeekOffRes: null,
      addWeekOffError: null,
    },
  };
};
const handleAddWeekOffSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      addWeekOffPending: false,
      addWeekOffRes: payload,
      addWeekOffError: null,
    },
  };
};
const handleAddWeekOffError = (state1, payload) => ({
  ...state1,
  ...{
    addWeekOffPending: false,
    addWeekOffRes: null,
    addWeekOffError: payload,
  },
});

//get employee by Shift Id
const handleGetEmployeeByShiftidRequest = state1 => {
  return {
    ...state1,
    ...{
      getEmployeebyShiftidPending: true,
      getEmployeebyShiftidRes: null,
      getEmployeebyShiftidError: null,
    },
  };
};
const handleGetEmployeeByShiftidSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEmployeebyShiftidPending: false,
      getEmployeebyShiftidRes: payload,
      getEmployeebyShiftidError: null,
    },
  };
};
const handleGetEmployeeByShiftidError = (state1, payload) => ({
  ...state1,
  ...{
    getEmployeebyShiftidPending: false,
    getEmployeebyShiftidRes: null,
    getEmployeebyShiftidError: payload,
  },
});

// Get All Shift Details
const handleGetAllShiftDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllShiftDetailsPending: true,
  getAllShiftDetailsRes: null,
  getAllShiftDetailsError: null,
    },
  };
};
const handleGetAllShiftDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllShiftDetailsPending: false,
  getAllShiftDetailsRes: payload,
  getAllShiftDetailsError: null,
    },
  };
};
const handleGetAllShiftDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    getAllShiftDetailsPending: false,
  getAllShiftDetailsRes: null,
  getAllShiftDetailsError: payload,
  },
});

// Delete Employee Shift Details
const handleDeleteEmployeeShiftRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteEmployeeShiftPending: true,
  deleteEmployeeShiftRes: null,
  deleteEmployeeShiftError: null,
    },
  };
};
const handleDeleteEmployeeShiftSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteEmployeeShiftPending: false,
      deleteEmployeeShiftRes: payload,
      deleteEmployeeShiftError: null,
    },
  };
};
const handleDeleteEmployeeShiftError = (state1, payload) => ({
  ...state1,
  ...{
    deleteEmployeeShiftPending: false,
  deleteEmployeeShiftRes: null,
  deleteEmployeeShiftError: payload,
  },
});

// Active Or inactive Shift Details
const handleActiveOrInactiveRequest = state1 => {
  return {
    ...state1,
    ...{
      activeOrInactivePending: true,
  activeOrInactiveRes: null,
  activeOrInactiveError: null,
    },
  };
};
const handleActiveOrInactiveSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      activeOrInactivePending: false,
  activeOrInactiveRes: payload,
  activeOrInactiveError: null,
    },
  };
};
const handleActiveOrInactiveError = (state1, payload) => ({
  ...state1,
  ...{
    activeOrInactivePending: false,
    activeOrInactiveRes: null,
    activeOrInactiveError: payload,
  },
});

// Active Or inactive Shift Details
const handleGetEmployeeShiftDetailsByIdRequest = state1 => {
  return {
    ...state1,
    ...{
      getEmployeeShiftDetailsByIdPending:true,
      getEmployeeShiftDetailsByIdRes:null,
      getEmployeeShiftDetailsByIdError:null,
    },
  };
};
const handleGetEmployeeShiftDetailsByIdSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEmployeeShiftDetailsByIdPending:false,
  getEmployeeShiftDetailsByIdRes:payload,
  getEmployeeShiftDetailsByIdError:null,
    },
  };
};
const handleGetEmployeeShiftDetailsByIdError = (state1, payload) => ({
  ...state1,
  ...{
    getEmployeeShiftDetailsByIdPending:false,
    getEmployeeShiftDetailsByIdRes:null,
    getEmployeeShiftDetailsByIdError:payload,
  },
});


// clear existing data
/* Clear Shift Store */
const clearShiftStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_SHIFT_STORE':
      return {
        ...state,
        ...{
          addShiftPending: false,
          addShiftRes: null,
          addShiftError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_SHIFT_STORE':
      return {
        ...state,
        ...{
          updateShiftPending: false,
          updateShiftRes: null,
          updateShiftError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_SHIFT_STORE':
      return {
        ...state,
        ...{
          deleteShiftPending: false,
          deleteShiftRes: null,
          deleteShiftError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_SHIFT_CONFIGURATION_STORE':
      return {
        ...state,
        ...{
          addShiftConfigurationPending: false,
          addShiftConfigurationRes: null,
          addShiftConfigurationError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_SHIFT_CALENDAR_STORE':
      return {
        ...state,
        ...{
          addShiftCalendarPending: false,
          addShiftCalendarRes: null,
          addShiftCalendarError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_SHIFT_CALENDAR_STORE':
      return {
        ...state,
        ...{
          updateShiftCalendarPending: false,
          updateShiftCalendarRes: null,
          updateShiftCalendarError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_SHIFT_CALENDAR_STORE':
      return {
        ...state,
        ...{
          deleteShiftCalendarPending: false,
          deleteShiftCalendarRes: null,
          deleteShiftCalendarError: null,
        },
      };
    case 'HANDLE_CLEAR_ASSIGN_SHIFT_STORE':
      return {
        ...state,
        ...{
          assignShiftPending: false,
          assignShiftRes: null,
          assignShiftError: null,
        },
      };
    case 'HANDLE_ADD_WEEK_OFF_STORE':
      return {
        ...state,
        ...{
          addWeekOffPending: false,
          addWeekOffRes: null,
          addWeekOffError: null,
        },
      };
      case 'DELECT_EMPLOYEE_SHIFT_STORE':
      return {
        ...state,
        ...{
          deleteEmployeeShiftPending: false,
          deleteEmployeeShiftRes: null,
          deleteEmployeeShiftError: null,
        },
      };
      case 'ACTIVE_INACTIVE_SHIFT_STORE':
        return {
          ...state,
          ...{
          activeOrInactivePending: false,
          activeOrInactiveRes: null,
         activeOrInactiveError: null
          },
        };
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.addShiftRequest]: handleAddShiftRequest,
    [actions.addShiftSuccess]: handleAddShiftSuccess,
    [actions.addShiftError]: handleAddShiftError,

    [actions.getAllShiftRequest]: handleGetAllShiftRequest,
    [actions.getAllShiftSuccess]: handleGetAllShiftSuccess,
    [actions.getAllShiftError]: handleGetAllShiftError,

    [actions.getShiftByIdRequest]: handleGetShiftByIdRequest,
    [actions.getShiftByIdSuccess]: handleGetShiftByIdSuccess,
    [actions.getShiftByIdError]: handleGetShiftByIdError,

    [actions.updateShiftRequest]: handleUpdateShiftRequest,
    [actions.updateShiftSuccess]: handleUpdateShiftSuccess,
    [actions.updateShiftError]: handleUpdateShiftError,

    [actions.deleteShiftRequest]: handleDeleteShiftRequest,
    [actions.deleteShiftSuccess]: handleDeleteShiftSuccess,
    [actions.deleteShiftError]: handleDeleteShiftError,

    [actions.addShiftConfigurationRequest]: handleAddShiftConfigurationRequest,
    [actions.addShiftConfigurationSuccess]: handleAddShiftConfigurationSuccess,
    [actions.addShiftConfigurationError]: handleAddShiftConfigurationError,

    // [actions.getShiftConfigurationRequest]: handleGetShiftConfigurationRequest,
    // [actions.getShiftConfigurationSuccess]: handleGetShiftConfigurationSuccess,
    // [actions.getShiftConfigurationError]: handleGetShiftConfigurationError,

    [actions.addShiftCalendarRequest]: handleAddShiftCalendarRequest,
    [actions.addShiftCalendarSuccess]: handleAddShiftCalendarSuccess,
    [actions.addShiftCalendarError]: handleAddShiftCalendarError,

    [actions.getAllShiftCalendarRequest]: handleGetAllShiftCalendarRequest,
    [actions.getAllShiftCalendarSuccess]: handleGetAllShiftCalendarSuccess,
    [actions.getAllShiftCalendarError]: handleGetAllShiftCalendarError,

    [actions.updateShiftCalendarRequest]: handleUpdateShiftCalendarRequest,
    [actions.updateShiftCalendarSuccess]: handleUpdateShiftCalendarSuccess,
    [actions.updateShiftCalendarError]: handleUpdateShiftCalendarError,

    [actions.deleteShiftCalendarRequest]: handleDeleteShiftCalendarRequest,
    [actions.deleteShiftCalendarSuccess]: handleDeleteShiftCalendarSuccess,
    [actions.deleteShiftCalendarError]: handleDeleteShiftCalendarError,

    [actions.assignShiftRequest]: handleAssignShiftRequest,
    [actions.assignShiftSuccess]: handleAssignShiftSuccess,
    [actions.assignShiftError]: handleAssignShiftError,

    [actions.addWeekOffRequest]: handleAddWeekOffRequest,
    [actions.addWeekOffSuccess]: handleAddWeekOffSuccess,
    [actions.addWeekOffError]: handleAddWeekOffError,

    [actions.getEmployeeByShiftIdRequest]:handleGetEmployeeByShiftidRequest,
    [actions.getEmployeeByShiftIdSuccess]:handleGetEmployeeByShiftidSuccess,
    [actions.getEmployeeByShiftIdError]:handleGetEmployeeByShiftidError,

    [actions.getAllShiftDetailsRequest]:handleGetAllShiftDetailsRequest,
    [actions.getAllShiftDetailsSuccess]:handleGetAllShiftDetailsSuccess,
    [actions.getAllShiftDetailsError]:handleGetAllShiftDetailsError,

    [actions.deleteEmployeeShiftRequest]:handleDeleteEmployeeShiftRequest,
    [actions.deleteEmployeeShiftSuccess]:handleDeleteEmployeeShiftSuccess,
    [actions.deleteEmployeeShiftError]:handleDeleteEmployeeShiftError,

    [actions.activeOrInactiveRequest]:handleActiveOrInactiveRequest,
    [actions.activeOrInactiveSuccess]:handleActiveOrInactiveSuccess,
    [actions.activeOrInactiveError]:handleActiveOrInactiveError,

    [actions.getEmployeeShiftDetailsByIdRequest]:handleGetEmployeeShiftDetailsByIdRequest,
    [actions.getEmployeeShiftDetailsByIdSuccess]:handleGetEmployeeShiftDetailsByIdSuccess,
    [actions.getEmployeeShiftDetailsByIdError]:handleGetEmployeeShiftDetailsByIdError,

    [actions.handleClearShiftStore]: clearShiftStore,
  },
  initialState,
);